import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ValueChange } from '@openx/types/auditTrail.ts';
import type { LabeledChange } from '@openx/utils/history/types.ts';
import type { JSX, ReactNode } from 'react';

import { ValuePlaceholder } from '../Value/ValuePlaceholder/ValuePlaceholder.tsx';

const StyledContainerDiv = styled('div')`
  align-items: center;
  display: flex;

  & > p {
    width: 49%;

    &::first-letter {
      text-transform: uppercase;
    }
  }
`;

interface SingleFieldValueChangeProps {
  change: LabeledChange<ValueChange>;
}

function valueNode(dataTest: string, value?: string): ReactNode {
  if (!value) {
    return <ValuePlaceholder component="p" dataTestParam={dataTest} />;
  }

  return (
    <Typography variant="body1" data-test={dataTest} component="div">
      {value}
    </Typography>
  );
}

export function SingleFieldValueChange({ change }: SingleFieldValueChangeProps): JSX.Element {
  const { new_value } = change;

  const newValueNode: ReactNode = valueNode('new-value', new_value);

  return <StyledContainerDiv data-test="operation">{newValueNode}</StyledContainerDiv>;
}
